import { PureComponent } from 'preact-compat';
import classNames from 'classnames';

import {FOOTSHOP_LOGO, FOOTSHOP_LOGO_COLORS} from './constants';

import {randomize} from './helpers';

import styles from './styles.scss';

export class Logo extends PureComponent {
    state = {
        type: FOOTSHOP_LOGO.TYPES.FOOTSHOP,
        scribble: randomize(FOOTSHOP_LOGO.SCRIBBLES[FOOTSHOP_LOGO.TYPES.FOOTSHOP].length)
    };

    componentDidMount() {
        if (window.innerWidth >= FOOTSHOP_LOGO.BREAKPOINT) {
            return;
        }

        this.setState({
            type: FOOTSHOP_LOGO.TYPES.FTSHP,
            scribble: randomize(FOOTSHOP_LOGO.SCRIBBLES[FOOTSHOP_LOGO.TYPES.FTSHP].length)
        });
    }

    renderSvg = (symbol) => {
        const width = FOOTSHOP_LOGO.ATTRS[this.state.type].WIDTH;
        const height = FOOTSHOP_LOGO.ATTRS[this.state.type].HEIGHT;

        return (
            <svg
                width={width}
                height={height}
                viewBox={`0 0 ${width} ${height}`}
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                className={classNames({
                    [styles.svgWhite]: this.props.color === FOOTSHOP_LOGO_COLORS.WHITE,
                    [styles.svgBlack]: this.props.color === FOOTSHOP_LOGO_COLORS.BLACK,
                })}
                dangerouslySetInnerHTML={{__html: symbol}}/>
        );
    };

    render() {
        return (
            <div className={styles.wrapper}>
                {this.renderSvg(FOOTSHOP_LOGO.SYMBOL[this.state.type])}
                <div className={styles.scribble}>
                    {this.renderSvg(FOOTSHOP_LOGO.SCRIBBLES[this.state.type][this.state.scribble || 0])}
                </div>
            </div>
        );
    }
}

export default Logo;



// WEBPACK FOOTER //
// ./components/logo/index.js